module.exports = __webpack_public_path__ + "media/card_carousel_mobile.66de739c.mp4";